const isValidDate = (value) => value instanceof Date && !isNaN(value);

export default isValidDate;
